/**
 * Translate a string with a `{n}` count (and optional extra placeholders), using the key's `.one`
 * variant when the count is 1 and the language defines one ("of 1 room" rather than "of 1 rooms").
 */
export function translateCount(t: (key: string) => string, key: string, n: number | null | undefined, extra: Record<string, string | number> = {}): string {
    const count = n ?? 0;
    const singular = `${key}.one`;
    const template = count === 1 && t(singular) !== singular ? t(singular) : t(key);
    let text = template.replace('{n}', String(count));
    for (const [name, value] of Object.entries(extra)) text = text.replace(`{${name}}`, String(value));
    return text;
}
